module.exports = __webpack_public_path__ + "static/Asana-a833812a8cd954630502f227476be0fb.png";